export default (state = { branches: [] }, action) => {
  switch (action.type) {
    case 'BRANCH_MANAGER_SET':
      return { ...state, ...action.branchManager };
    case 'BRANCHES_SET':
      return { ...state, branches: action.branches };
    default:
      return state;
  }
};
